import NavigationForm from './NavigationForm'

const Create = () => {
    return (
        <NavigationForm
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Navigation created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create navigation',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating navigation...',
                },
            }}
        />
    )
}

export default Create
